import { faTimes,faUnlock } from '@fortawesome/free-solid-svg-icons'
import styled from 'styled-components'

import { Button } from '@/components'
import { Modal } from '@/components/Modal/Modal'
import { StructureObjectDto } from '@/endpoints/models'
import { useAppContext, useAppDispatch,useAppStore } from '@/hooks'
import { unlockNode } from '@/store/modules/node/actions'
import { logError } from '@/utils/errorHandling'
import { isLockedByMe } from '@/utils/locking'

import { useTreePanelOperations } from './TreePanel/TreePanelContext'

type Props = {
	node: StructureObjectDto
	onClose: () => void
	onConfirm?: () => void
	onRefresh?: () => void
}

export const UnlockModal = ({ node, onClose, onConfirm, onRefresh }: Props) => {
	const { t } = useAppContext()
	const dispatch = useAppDispatch()
	const user = useAppStore((state) => state.auth.user)
	const { refreshSystemsSilent } = useTreePanelOperations()

	const handleConfirm = async () => {
		await dispatch(unlockNode(node))
		refreshSystemsSilent().catch((e) =>
			logError(e, { operation: 'UnlockModal.refreshSystemsSilent' }),
		)
		onClose()
		onConfirm?.()
		onRefresh?.()
	}

	return (
		<Modal
			open={true}
			contentStyle={{
				width: '400px',
			}}
			header={t('UNLOCK_HEADER')}
			footer={(close) => (
				<>
					<Button icon={faUnlock} schema="warn" onClick={handleConfirm}>
						{t('YES')}
					</Button>
					<Button schema="transparent" onClick={close} icon={faTimes}>
						{t('NO')}
					</Button>
				</>
			)}
			onClose={onClose}
		>
			<PopupText>
				<span>
					{isLockedByMe(node, user)
						? t('UNLOCK_MESSAGE_LOCKED_BY_YOU')
						: t('UNLOCK_MESSAGE_LOCKED_BY_USER', [node.lockUserName as string])}
				</span>
			</PopupText>
		</Modal>
	)
}

const PopupText = styled.div`
	display: flex;
	align-items: center;
`
